


import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"

const REPO_URL = {
    getListOrg: '/report/org',
    getListDiv: '/report/div',
    getListDept: '/report/dept',
    getListPos: '/report/pos',
    getListWbs: '/report-wbs-form/paginated',
    getDetailsWbs: '/wbs/content/wbsid',
}

const useReportRepo = (initialLoading = false) => {
    const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading)

    const getReportOrgList = async (payload) => {
        return await executeApi(REPO_URL.getListOrg, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getReportDivisionList = async (payload) => {
        return await executeApi(REPO_URL.getListDiv, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getReportDepartmentList = async (payload) => {
        return await executeApi(REPO_URL.getListDept, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getReportPositionList = async (payload) => {
        return await executeApi(REPO_URL.getListPos, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getReportWbsList = async (payload) => {
        return await executeApi(REPO_URL.getListWbs, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getReportDetailWbs = async (payload) => {
        return await executeApi(REPO_URL.getDetailsWbs, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    

    return {
        isLoading,
        data,
        error,
        getReportOrgList,
        getReportDivisionList,
        getReportDepartmentList,
        getReportPositionList,
        getReportWbsList,
        getReportDetailWbs
    }
}

export default useReportRepo
